import { isDateValid } from 'sos-common/js/utils/date';

export function validateUtbildningstid(
  value: string,
  max: number,
  translations: (key: string, defaultValue?: string) => string
) {
  value = value?.replace(',', '.');
  const onlyNumbersInvalid = validateDoubleOrWholeNumber(value, translations('errorMessages/onlyNumbersAndDecimals'));

  if (onlyNumbersInvalid) return onlyNumbersInvalid;

  const num = Number.parseFloat(value.replace(' ', ''));
  if (num > max) return `${translations('errorMessages/maxNr')} ${max}.`;
  if (num === 0) return `${translations('errorMessages/biggerThanZero')}`;
  return '';
}

function validateOnlyNumbers(value: string, errorMessage?: string) {
  // should match: digits, ignoring whitespace
  const isValid = value?.replace(/\s/g, '').match(/^\d+$/);
  if (!isValid) return errorMessage;
  return '';
}

function validateDoubleOrWholeNumber(value: string, errorMessage?: string) {
  // should match: digits, ignoring whitespace
  const isValid = value?.replace(/\s/g, '').match(/^\d*(\.\d)?$/);
  if (!isValid) return errorMessage;
  return '';
}

export function validateCentury(value: string, translations: (key: string, defaultValue?: string) => string) {
  const onlyNumbersError = validateOnlyNumbers(value, translations('errorMessages/onlyNr'));
  if (onlyNumbersError) return onlyNumbersError;

  const pattern = /^(19|20)\d\d$/;
  if (!pattern.test(value)) return translations('errorMessages/validationOfYear');

  //can't be higher than today
  const currentYear = new Date().getFullYear();
  if (parseInt(value) > currentYear) return translations('errorMessages/yearNotAfterToday');

  return '';
}

export function validateDateFormat(value: string, errorMessageWrongFormat?: string, errorMessageDateToLate?: string) {
  //validate format
  const pattern = /^(19|20)\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
  if (!pattern.test(value)) return;

  //validate date
  const valueSplit = value.split('-');
  if (!isDateValid(valueSplit[0], valueSplit[1], valueSplit[2])) return errorMessageWrongFormat;

  //can't be higher than today
  if (Date.parse(value) > Date.now()) return errorMessageDateToLate;

  return '';
}
